/**
 * Set a cookie
 * @param cname {string}
 * @param cvalue {string}
 * @param exdays {number}
 */
export function setCookie(cname, cvalue, exdays) {
  let d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

/**
 * Get a cookie
 * @param cname {string}
 * @return {string}
 */
export function getCookie(cname) {
  let name = cname + '=';
  let ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1);
    if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
  }
  return '';
}

export function applyResponsiveStyle(elm, style) {
  elm.removeAttribute('style');

  const x = () =>
    Object.keys(style).forEach(width => {
      if (window.innerWidth >= width) Object.keys(style[width]).forEach(prop => (elm.style[prop] = style[width][prop]));
    });

  x();

  window.addEventListener('resize', evt => x());
}

export function loadScripts(pixel) {
  ['head', 'body'].forEach(section => {
    /** Parse the dom from settings */
    let domP = new DOMParser();
    let dom = domP.parseFromString(pixel[section], 'text/html');

    for (let i = 0; i < dom[section].children.length; i++) {
      let tag = dom[section].children[i];

      /** If is an inline script embed as data url */
      if (tag.tagName.toLowerCase() === 'script' && !tag.src) {
        let script = document.createElement('SCRIPT');
        script.src = 'data:text/javascript;base64,' + btoa(tag.innerHTML);

        /** Copy attributes */
        for (let ai = 0; ai < tag.attributes.length; ai++) {
          script[tag.attributes[ai].name] = tag.attributes[ai].value;
        }

        document[section].appendChild(script);
        continue;
      }

      /** Append tag to the section */
      document[section].appendChild(tag);
    }
  });
}

export function showConsentDialog(pixel, locale, onConsent) {
  if (getCookie('tpixel_gdpr_consent') === '1') return onConsent();

  let dialog = document.createElement('div');

  let gdprText = document.createElement('P');
  gdprText.setAttribute('style', 'text-align: start;color: inherit;font: inherit;line-height: inherit;');
  gdprText.innerHTML = locale.message.replace(/\s+/g, ' ');

  gdprText.querySelectorAll('a').forEach(a => (a.style.display = 'inline-block'));

  dialog.appendChild(gdprText);

  applyResponsiveStyle(dialog, {
    0: {
      all: 'initial',
      boxSizing: 'border-box',
      position: 'fixed',
      zIndex: 'var(--tp-dialog-z-index, 11000)',
      bottom: 'var(--tp-dialog-bottom-mobile, 0)',
      insetInlineEnd: 'var(--tp-dialog-end-mobile, 0)',
      width: 'var(--tp-dialog-width-mobile, 100%)',
      maxWidth: '100%',
      padding: 'var(--tp-dialog-padding, 1rem)',
      backgroundColor: 'var(--tp-dialog-bg, #fff)',
      color: 'var(--tp-dialog-color, #000)',
      fontFamily: 'var(--tp-dialog-font-family, sans-serif)',
    },
    996: {
      width: 'var(--tp-dialog-width-desktop, 400px)',
      bottom: 'var(--tp-dialog-bottom-desktop, 1rem)',
      insetInlineEnd: 'var(--tp-dialog-end-desktop, 1rem)',
      borderRadius: 'var(--tp-dialog-border-radius, 7px)',
      boxShadow: 'var(--tp-dialog-shadow, 0 4px 6px 0 rgba(0,0,0,0.2),5px 5px 10px 0 rgba(0,0,0,0.19))',
    },
  });

  let footer = document.createElement('div');
  footer.style.marginTop = '1rem';
  footer.style.display = 'flex';
  footer.style.justifyContent = 'flex-end';

  let declineBtn = document.createElement('button');
  declineBtn.type = 'button';
  declineBtn.innerText = locale.decline;

  declineBtn.style.cursor = 'pointer';
  declineBtn.style.marginInlineEnd = '1rem';

  declineBtn.style.backgroundColor = 'var(--tp-btn-decline-bg, #5c5c5c)';
  declineBtn.style.color = 'var(--tp-btn-decline-color, #fff)';
  declineBtn.style.padding = 'var(--tp-btn-decline-padding, .5rem)';
  declineBtn.style.borderRadius = 'var(--tp-btn-decline-border-radius, 7px)';

  declineBtn.addEventListener('click', evt => {
    setCookie('tpixel_gdpr_consent', '0', 365);
    dialog.remove();
  });

  footer.appendChild(declineBtn);

  let consentBtn = document.createElement('button');
  consentBtn.type = 'button';
  consentBtn.innerText = locale.agree;

  consentBtn.style.cursor = 'pointer';

  consentBtn.style.backgroundColor = 'var(--tp-btn-consent-bg, #1a936f)';
  consentBtn.style.color = 'var(--tp-btn-consent-color, #fff)';
  consentBtn.style.padding = 'var(--tp-btn-consent-padding, .5rem)';
  consentBtn.style.borderRadius = 'var(--tp-btn-consent-border-radius, 7px)';

  consentBtn.addEventListener('click', evt => {
    onConsent();
    setCookie('tpixel_gdpr_consent', '1', 365);
    dialog.remove();
  });

  footer.appendChild(consentBtn);

  dialog.appendChild(footer);

  document.body.appendChild(dialog);
}
